export const exportHeaders = [
    {
        label: "Template",
        key: "template"
    },

    {
        label: "Status",
        key: "is_active"
    },

    {
        label: "Enable Email",
        key: "enable_email"
    },

    {
        label: "Domain Name",
        key: "domain_name"
    },

    {
        label: "Reply Email",
        key: "reply_to"
    },

    
]